import { useId } from "react";

interface ToggleProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  helper?: string;
  error?: string;
  id?: string;
}

export default function Toggle({
  label,
  checked,
  onChange,
  disabled,
  helper,
  error,
  id,
}: ToggleProps) {
  const autoId = useId();
  const toggleId = id ?? autoId;

  return (
    <div className="w-full">
      <div className="flex items-center gap-3">
        <button
          type="button"
          role="switch"
          id={toggleId}
          aria-checked={checked}
          disabled={disabled}
          onClick={() => onChange(!checked)}
          className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 ${
            checked ? "bg-primary-500" : "bg-slate-300"
          }`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
              checked ? "translate-x-[22px]" : "translate-x-0.5"
            }`}
          />
        </button>
        {label && <span className="text-sm text-ink">{label}</span>}
      </div>
      {error ? (
        <p className="mt-1 text-xs text-danger">{error}</p>
      ) : helper ? (
        <p className="mt-1 text-xs text-ink-muted">{helper}</p>
      ) : null}
    </div>
  );
}